import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { ProductRepository } from "@/repositories/product";
import { AddProduct } from "@/types";

export const useAddProduct = () => {
  const productRepository = useRef(new ProductRepository());

  return useMutation({
    mutationFn: async (data: AddProduct) => {
      return productRepository.current.add(data);
    },
  });
};
